import React from "react";
import { Card, Col, Container, Row, CardBody } from "reactstrap";

import WelcomeImg from "../../../assets/images/welcome_v2.png";

const Welcome = () => {
  document.title = "Hoşgeldiniz | Metiner Avantaj+";

  return (
    <React.Fragment>
      <div className="auth-page-wrapper d-flex justify-content-center align-items-center min-vh-100">
        <div className="auth-page-content">
          <Container>
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="overflow-hidden">
                  <CardBody className="p-4 text-center">
                    <div className="text-center">
                      <a
                        href="https://metinerotomotivbcs.com/AppointmentBosch.aspx#/booking/service/list"
                        className="d-inline-block auth-logo"
                      >
                        <img
                          src={WelcomeImg}
                          alt="Metiner Avantaj+"
                          className="w-100"
                        />
                      </a>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>

        <footer className="footer h-auto pb-2">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center text-muted">
                  <p className="mb-2" style={{ letterSpacing: "0.8px" }}>
                    Metiner Avantaj+ &copy; {new Date().getFullYear()} | 0 352 3
                    555 444 | metiner@boschservice.com.tr
                    <br />
                    <i className="mdi mdi-heart text-danger"></i> by{" "}
                    <a
                      href="https://kodexis.com/"
                      target="_blank"
                      rel="noreferrer"
                      style={{ textDecoration: "none", color: "#007bff" }}
                    >
                      Kodexis
                    </a>
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </footer>
      </div>
    </React.Fragment>
  );
};

export default Welcome;
